import { Box, CircularProgress } from "@mui/material"
import { useContext, useEffect } from "react"
import { NotesContext, TBookingNotesRes } from "../NotesModuleContext"
import ReadOnlyTextField from "@/components/field-components/ReadOnlyTextField"
import styles from "./BookingNotes.module.css"
import { useQuery } from "react-query"
import { apiClient } from "@/apiClient/apiService"
import API_END_POINT, { ROUTES } from "@/apiClient/apiEndpoints"

const BookingNotes = () => {
  const { bookingNotes } = useContext(NotesContext)

  const { reservationId, eventType } = bookingNotes as any

  const { data, isFetching } = useQuery<{ data: TBookingNotesRes }>({
    queryKey: ["arrivalDepartureDetailData"],
    queryFn: async () => {
      return await apiClient.post(`${API_END_POINT.POST[ROUTES.getBookingNotes]}`, {
        reservationId,
      })
    },
    enabled: typeof reservationId !== "undefined",
    refetchOnWindowFocus: false,
  })

  const guestNote = data?.data?.current_booking_details?.guestNote ?? ""
  const hostNote = data?.data?.current_booking_details?.hostNote ?? ""
  const nextNotes = data?.data?.next_booking_details?.notes ?? ""

  let notes = guestNote
  if (guestNote) notes += "\n"
  notes += hostNote

  return (
    <Box className={styles.BookingSection}>
      <Box className={styles.Title}>Booking Notes</Box>
      <Box className={styles.BookingDetails}>
        {isFetching ? (
          <>
            <CircularProgress className={styles.Loader} />
          </>
        ) : (
          <>
            <ReadOnlyTextField
              fieldName={"This Booking Notes"}
              value={notes} //
              fullWidth
              multiLine
              row={4}
              highlightField={notes.length > 0 && eventType === "arrival"}
            />
            <ReadOnlyTextField
              fieldName={"Next Booking Notes"} //
              value={nextNotes}
              fullWidth
              multiLine
              row={4}
              highlightField={nextNotes.length > 0 && eventType === "departure"}
            />
          </>
        )}
      </Box>
    </Box>
  )
}

export default BookingNotes
